import React, { useCallback } from 'react'
import { Link } from 'gatsby'
import { fireEvent } from '@/utils/activityLog'
import { useGetCurrentPath } from '@/utils/hooks/useGetCurrentPath'
import { Category } from '@/components/atoms/entrypoint'
import * as style from './index.module.css'

interface Props {
  node: {
    /** 案件のid */
    projectsId: string
    /** 案件のタイトル */
    title: string
    /** 案件の領域 */
    field: string
    /** 案件の単価 */
    price: string
  }
}

/**
 * @file 案件の共通components
 */
export const Projects = ({ node }: Props): React.JSX.Element => {
  const { currentPath } = useGetCurrentPath()
  const { projectsId, title, field, price } = node

  const onClickNews = useCallback((): void => {
    fireEvent({
      event: 'clickProjectsId',
      parameters: {
        projects_id: projectsId,
        projects_title: title,
        current_path: currentPath,
      },
    })
  }, [title, currentPath])

  return (
    <Link
      className={style.link}
      to={`/projects/${projectsId}`}
      onClick={onClickNews}
    >
      <div className={style.root} aria-label={`「${title}」の詳細をみる`}>
        <div className={style.content}>
          <div className={style.subContent}>
            <Category category={field} />
          </div>
          <h3 className={style.title}>{title}</h3>
          <p className={style.price}>{`単価${price}万`}</p>
          <p className={style.linkText}>詳細をみる</p>
        </div>
      </div>
    </Link>
  )
}
